export default "__VITE_ASSET__CWWI$Khx__"